import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import AddEnquiryLayer from "../components/AddEnquiryLayer";

const AddEnquiryPage = () => {
    return (
        <MasterLayout>
            <AddEnquiryLayer />
        </MasterLayout>
    );
};

export default AddEnquiryPage;
